import React, { ReactNode } from "react";
import { GenericCardContent } from "@thrivetribe/mvf.ui.molecules.generic-card";
import "./generic-card.scss";

export type GenericCardProps = {
  children?: ReactNode;
  title: string;
  description: string;
};

export const GenericCard: React.FC<GenericCardProps> = ({
  children,
  title,
  description,
}: GenericCardProps) => {
  return (
    <div className="generic-card">
      <GenericCardContent title={title} description={description} />
      {children}
    </div>
  );
};
